<template>
  <div class="twui-view">
    <div class="twui-404" :style="{ minHeight: minHeight}">
      <div class="twui-404-inner">
        <img src="../static/images/404.png" />
        <p>很抱歉，页面走丢了</p>
        <a @click="backPrevPage">返回上一个页面</a>
        <a>重新登录</a>
      </div>
    </div>
  </div>
</template>

<script>
  import router from '@/config/router'

  export default {
    name: 'tw404',
    data () {
      return {
        minHeight: 0
      }
    },
    methods: {
      backPrevPage: function () {
        router.go(-1)
      }
    },
    mounted: function () {
      this.minHeight = window.innerHeight - 180 + 'px'
    }
  }
</script>



// WEBPACK FOOTER //
// 404.vue?0918c56c